import { computed } from 'vue'
import store from '/@/store'

export function useVideoFrame () {
  const liveStreamFramesZIndexCounter = computed(() => {
    return store.state.liveStreamFramesZIndexCounter
  })

  const liveStreamFrames = computed(() => {
    return store.state.liveStreamFrames
  })

  const addFrame = (src:string) => {
    console.log('add frame source: ' + src)
    const zindex = liveStreamFramesZIndexCounter.value + 1
    const frames = liveStreamFrames.value
    const frameObj = {
      id: Date.now(),
      src: src,
      zIndex: zindex,
    }
    frames.push(frameObj)
    store.commit('SET_LIVESTREAM_FRAMES_Z_INDEX_COUNTER', zindex)
    store.commit('SET_LIVESTREAM_FRAMES', frames)
  }

  return {
    addFrame
  }
}
